import {
  GET_ACTIVE_PAGE,
  SET_CUSTOMERID,
  SET_SHOPDOMAIN,
  SET_PARENTLOCATION,
  SET_ISDISCOUNTCARD,
} from "../actions/constants/constants";

export const setActivePage = (page) => ({
  type: GET_ACTIVE_PAGE,
  payload: page,
});

export const setCustomerId = (id) => ({
  type: SET_CUSTOMERID,
  payload: id,
});

export const setShopDomain = (shopdomain) => ({
  type: SET_SHOPDOMAIN,
  payload: shopdomain,
});

export const setParentLocation = (parentLocation) => ({
  type: SET_PARENTLOCATION,
  payload: parentLocation,
});
export const setIsDiscountCard = (isDiscountCard) => ({
  type: SET_ISDISCOUNTCARD,
  payload: isDiscountCard,
});
